import React from 'react';

const LoadingPopup = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-lg">
        <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
        <p className="text-gray-700">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingPopup;
